import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const LINQ = () => {
  return (
    <StartInterviewLayout type="linq"/>
  )
}

export default LINQ;